/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Info } from './Info';
import {
    InfoFromJSON,
    InfoFromJSONTyped,
    InfoToJSON,
} from './Info';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * 
 * @export
 * @interface EntityEdge
 */
export interface EntityEdge {
    /**
     * 
     * @type {string}
     * @memberof EntityEdge
     */
    fromNodeId: string;
    /**
     * 
     * @type {string}
     * @memberof EntityEdge
     */
    toNodeId: string;
    /**
     * 
     * @type {Array<Info>}
     * @memberof EntityEdge
     */
    infos: Array<Info>;
    /**
     * 
     * @type {Array<Value>}
     * @memberof EntityEdge
     */
    propertyValues: Array<Value>;
}

/**
 * Check if a given object implements the EntityEdge interface.
 */
export function instanceOfEntityEdge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fromNodeId" in value;
    isInstance = isInstance && "toNodeId" in value;
    isInstance = isInstance && "infos" in value;
    isInstance = isInstance && "propertyValues" in value;

    return isInstance;
}

export function EntityEdgeFromJSON(json: any): EntityEdge {
    return EntityEdgeFromJSONTyped(json, false);
}

export function EntityEdgeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityEdge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromNodeId': json['fromNodeId'],
        'toNodeId': json['toNodeId'],
        'infos': ((json['infos'] as Array<any>).map(InfoFromJSON)),
        'propertyValues': ((json['propertyValues'] as Array<any>).map(ValueFromJSON)),
    };
}

export function EntityEdgeToJSON(value?: EntityEdge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromNodeId': value.fromNodeId,
        'toNodeId': value.toNodeId,
        'infos': ((value.infos as Array<any>).map(InfoToJSON)),
        'propertyValues': ((value.propertyValues as Array<any>).map(ValueToJSON)),
    };
}

